import { useSuspenseQuery } from '@tanstack/react-query';

import { UserProfileService } from '../services/profile.service';
import { OVERVIEW_QUERY_KEYS } from '../constants';

export const useGetUserProfile = () => {
  return useSuspenseQuery({
    queryKey: [OVERVIEW_QUERY_KEYS.USER_PROFILE],
    queryFn: () => UserProfileService.getUserProfile(),
    select(data) {
      return data?.data;
    },
    staleTime: Infinity,
    gcTime: Infinity,
  });
};
